module.exports = __webpack_public_path__ + "blacktowel.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blacktowel.png
// module id = 871
// module chunks = 0